// extracted by mini-css-extract-plugin
export default {"stickyWhatsapp":"styles_stickyWhatsapp__cT1IK"};